import { useQuery } from '@tanstack/react-query'
import { listImportBeats } from 'supabase/importBeats'

/**
 * Every import beat for the Beats page. `total` is the server's own count;
 * `isShort` is true when it is missing or larger than what came back, i.e. the
 * list was cut (PostgREST caps a select at 1000 rows) and must not be read as
 * complete. Never infer a total from the rows.
 */
export const useQueryImportBeats = () => {
  const { isLoading, isError, error, data } = useQuery({
    queryKey: ['importBeats'],
    queryFn: listImportBeats
  })

  const beats = data?.rows ?? []
  const total = data?.total ?? null
  const isShort = total === null || total > beats.length

  return {
    isLoading,
    isError,
    error,
    beats,
    total,
    isShort
  }
}
